import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, FormControlLabel, Checkbox } from '@mui/material';

const EditImplantSystem = ({ handleEditImplantSystemClose, showEditImplantSystem, selectedRowData, editRows, onRowsUpdate }) => {
    const [rows, setRows] = useState(editRows);
    const [valueName, setValueName] = useState('');
    const [allowNoteForLot, setAllowNoteForLot] = useState(false);
    const [allowNoteForSerial, setAllowNoteForSerial] = useState(false);
    const [isLotRequired, setIsLotRequired] = useState(false);
    const [isSerialRequired, setIsSerialRequired] = useState(false);
    const [classification, setClassification] = useState("");
    const [pricing, setPricing] = useState([]);
    const [diameters, setDiameters] = useState([]);
    const [specialPricings, setSpecialPricings] = useState([]);


    useEffect(() => {
        if (selectedRowData) {
          
          const rowData = selectedRowData[0];
          setValueName(rowData?.valueName || '');
          setAllowNoteForLot(rowData?.allowNoteForLot || false);
          setIsLotRequired(rowData?.isLotRequired || false);
          setAllowNoteForSerial(rowData?.allowNoteForSerial || false);
          setIsSerialRequired(rowData?.isSerialRequired || false);
          setClassification(rowData?.classification || []);
          
          setPricing(rowData?.pricing)
          setDiameters(rowData?.diameter);
          setSpecialPricings(rowData?.specialPricing)
        }
      }, [selectedRowData]);
    
      //main checkboxes
      const handleAllowNoteForLot = () => {
        setAllowNoteForLot(!allowNoteForLot);
      };

      const handleAllowNoteForSerial = () => {
        setAllowNoteForSerial(!allowNoteForSerial); 
      };

      const handleIsLotRequired = () => {
        setIsLotRequired(!isLotRequired); 
      };

      const handleIsSerialRequired = () => {
        setIsSerialRequired(!isSerialRequired);
      };

      const handleRollUpPriceChange = (index, e) => {
        const newPricing = [...pricing]; 
        newPricing[index].rollUpPrice = !newPricing[index].rollUpPrice; 
        setPricing(newPricing); 
      };

      const handleSuppressWhenZero = (index, e) => {
        const newPricing = [...pricing]; 
        newPricing[index].suppressWhenZero = !newPricing[index].suppressWhenZero; 
        setPricing(newPricing); 
      };

      const handleSuppressOnReports = (index, e) => {
        const newPricing = [...pricing]; 
        newPricing[index].suppressOnReports = !newPricing[index].suppressOnReports; 
        setPricing(newPricing); 
      };
    
      

      const handleSave = async () => {
        try {
          const putData = {
            valueName,
            allowNoteForLot,
            allowNoteForSerial,
            isLotRequired,
            isSerialRequired,
            classification,
            diameters,
            pricing,
            pricing_id: pricing._id,
            specialPricings,
          };
    
          
          const response = await fetch(`https://hms.backend.hiragroupcloud.com/api/implant-systems/${selectedRowData[0]._id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(putData),
          });
      
          if (!response.ok) {
            throw new Error('Failed to update data');
          }
      
          const updatedRow = await response.json();
         
          
          const MyUpdatedRows = setRows(prevRows => prevRows.map(row => (row._id === updatedRow.data._id ? updatedRow.data : row)));
          
      
          handleEditImplantSystemClose();
        } catch (error) {
          console.error('Error updating data:', error);
        }
      };


      // useEffect(() => {
       
      //   if (selectedRowData) {
      //       setRows(prevRows =>
      //           prevRows.map(row =>
      //               row._id === selectedRowData[0]._id ? selectedRowData[0] : row
      //           )
      //       );
      //   }
      //   }, [selectedRowData[0]]);

        useEffect(() => {

        }, [rows]); 

      const handleValueNameChange = (e) => {
        setValueName(e.target.value)
      }

      const handleClassificationChange = (e) => {
        setClassification(e.target.value)
      }

   

      const handleTaxable = (index, e) => {
        const newPricing = [...pricing]; 
        newPricing[index].taxable = e.target.value; 
        setPricing(newPricing); 
      };
        
      const handleDefaultPrice = (index, e) => {
          const newPricing = [...pricing]; 
          newPricing[index].amount = e.target.value;
          setPricing(newPricing); 
      };

      // handle compositions

      const handleInputValue = (index, e) => {
        const newDiameters = [...diameters]; 
        newDiameters[index].inputValue = e.target.value; 
        setDiameters(newDiameters); 
        };


      //handle special pricings
      
      const handlePrice = (index, e) => {
        const newSpecialPricings = [...specialPricings]; 
        newSpecialPricings[index].price = e.target.value; 
        setSpecialPricings(newSpecialPricings);
      };
      const handlePricingFor = (index, e) => {
        const newSpecialPricings = [...specialPricings]; 
        newSpecialPricings[index].pricingFor = e.target.value; 
        setSpecialPricings(newSpecialPricings); 
      };
      // const handleGroup = (index, e) => {
      //   const newSpecialPricings = [...specialPricings]; 
      //   newSpecialPricings[index].group = e.target.value; 
      //   setSpecialPricings(newSpecialPricings); 
      // };
      const handleAccount = (index, e) => {
        const newSpecialPricings = [...specialPricings]; 
        newSpecialPricings[index].account = e.target.value; 
        setSpecialPricings(newSpecialPricings); 
      };
      const handleProcedure = (index, e) => {
        const newSpecialPricings = [...specialPricings]; 
        newSpecialPricings[index].procedure = e.target.value;
        setSpecialPricings(newSpecialPricings); 
      };



  return (
    <>
    <div>{/* Modal for Editing */}
    <Dialog open={showEditImplantSystem} onClose={handleEditImplantSystemClose}>
      <DialogTitle>Edit Implant Systems</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Value Name"
          type="text"
          fullWidth
          variant="outlined"
          value={valueName}
          onChange={handleValueNameChange}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={isLotRequired === true}
              onChange={handleIsLotRequired}
              color="primary"
            />
          }
          label="Lot Required"
        />
        
        <FormControlLabel
          control={
            <Checkbox
              checked={allowNoteForLot === true}
              onChange={handleAllowNoteForLot}
              color="primary"
            />
          }
          label="Allow Note for Lot"
        />
        
        <FormControlLabel
          control={
            <Checkbox
              checked={isSerialRequired === true}
              onChange={handleIsSerialRequired}
              color="primary"
            />
          }
          label="Serial Required"
        />
        
        <FormControlLabel
          control={
            <Checkbox
              checked={allowNoteForSerial === true}
              onChange={handleAllowNoteForSerial}
              color="primary"
            />
          }
          label="Allow Note for Serial"
        />
        <TextField
          margin="dense"
          label="Classification"
          type="text"
          fullWidth
          variant="outlined"
          value={classification || ''}
          onChange={handleClassificationChange}
        />

        {pricing?.map((column, index) => ( 
            <>
                <div key={column._id} className='row'>
                    <h3>Pricing</h3>
                    <div className='col-md-6'>
                        <TextField
 
                            margin="dense"
                            label="Taxable"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={column.taxable || ''}
                            onChange={(e) => handleTaxable(index, e)}
                        />
                    </div>
                    <div className='col-md-6'>
                        <TextField

                            margin="dense"
                            label="Default Price"
                            type="number"
                            fullWidth
                            variant="outlined"
                            value={column.amount || ''}
                            onChange={(e) => handleDefaultPrice(index, e)}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <FormControlLabel
                            control={
                                <Checkbox
                                checked={column.rollUpPrice === true}
                                onChange={(e) => handleRollUpPriceChange(index, e)}
                                color="primary"
                                />
                            }
                            label="Never roll-up price into procedure"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                checked={column.suppressWhenZero === true}
                                onChange={(e) => handleSuppressWhenZero(index, e)}
                                color="primary"
                                />
                            }
                            label="Suppress this attribute value when price is zero"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                checked={column.suppressOnReports === true}
                                onChange={(e) => handleSuppressOnReports(index, e)}
                                color="primary"
                                />
                            }
                            label="Suppress this attribute on reports"
                        />
                    </div>
                </div>
            </>
        ))}
        {specialPricings?.map((column, index) => (
            <div key={column._id} >
                <h3>Special Pricing </h3>
                <div className='row'>
                    <div className='col-md-6'>
                        <TextField

                            margin="dense"
                             label="Price"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={column.price}
                            onChange={(e) => handlePrice(index, e)}
                        />
                    </div>
                    <div className='col-md-6'>
                        <TextField
                            margin="dense"
                              label="Groups"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={column.pricingFor}
                            onChange={(e) => handlePricingFor(index, e)}
                        />
                    </div>
                </div>
                   
                    <div className="row-md-6">
                        <TextField
                            margin="dense"
                            label={column.account}
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={column.account}
                            onChange={(e) => handleAccount(index, e)}
                        />
                        <TextField
                            margin="dense"
                            label={column.procedure}
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={column.procedure}
                            onChange={(e) => handleProcedure(index, e)}
                        />
                    </div>
            </div>  
        ))} 
          {/* COMPOSITIONS STARTS */}

          {diameters?.map((column, index) => ( 
            
            <div key={column._id} className='row'>
                <h3>Diameter {index+1}</h3>
                <div className='col-md-6'>
                    <TextField
                  
                        margin="dense"
                        label="Input Value"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={column.inputValue}
                        onChange={(e) => handleInputValue(index, e)}
                    />
                </div>
          </div>
         ))} 


        {/* COMPOSITIONS ENDS */}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleEditImplantSystemClose}>Cancel</Button>
        <Button onClick={handleSave}>Save Change</Button>
      </DialogActions>
    </Dialog>
    </div>
    </>
  )
}

export default EditImplantSystem;